import UnpublishButton from './UnpublishButton.vue';

export default UnpublishButton;
